import type { FaireProductEntity } from "../../entity_types/product";

export const p_rpfg2nppf4: FaireProductEntity = {
  token: "p_rpfg2nppf4",
  type: "product",
  name: "Scented Soy Candle Essentials Gift Set",
  brandToken: "b_cefgzfyh",
  brandName: "Jack Be Nimble Candles",
  imageUrl:
    "https://cdn.faire.com/fastly/6c8907f8818897007ef7cb7b506238c0a292a058863c4f97166993fa623298d0.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/ed32204d98129a625a651fdb96b387e40bd5e608b694dd17f98194ada7ae5bd5.jpeg",
    "https://cdn.faire.com/fastly/7400e79ac156e88929d5690a068d1128f4dac71c610dac3b86a30bea5322f7aa.jpeg",
    "https://cdn.faire.com/fastly/7c51640b2c301a0b02fd100ce8b5aecf4ce71d3e0cbe2950a5babcb25050b5a3.jpeg",
    "https://cdn.faire.com/fastly/8c8768cd461d9594784cdac7213821f07e9e8bb8c0a9dc684538f11f3c33d44a.jpeg",
  ],
  priceDollars: 34,
  description:
    'Prepackaged and perfectly giftable. Each gift set comes with a curated selection of three mini candles.\n\nWhy get one when you can have them all? The Jack Be Nimble Essentials gift set includes our three best-selling candles scents. This trio of luxe mini candles is a superb gift for someone who\'s incredibly chic. The matte white glass and smoked wood lid vessels look great on any table or dresser. Packaged in a Jack Be Nimble branded matte white gift box and ready for gifting! \n\n DETAILS\n\n• Scents include: Day At The Spa, Southern Sunshine, and Woodland\n• Contains: (3) 5.5 oz candles. Each measuring 2.75" in diameter and 3.25" in height\n• Gift box measures: 10.4" width, 3.5" height, and 3.8" depth\n• Burn time: Approx. 25-30 hours per candle / 75-90 hours combined burn time\n• Pro tip: add a bow and gift in style!\n• Prefect gift for Mother\'s Day\n',
  tags: [],
  msrpDollars: 68,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:53:22.760Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
